import { render, staticRenderFns } from "./situationExplaination.vue?vue&type=template&id=45b0d268&scoped=true&"
import script from "./situationExplaination.vue?vue&type=script&lang=js&"
export * from "./situationExplaination.vue?vue&type=script&lang=js&"
import style0 from "./situationExplaination.vue?vue&type=style&index=0&id=45b0d268&prod&lang=scss&"
import style1 from "./situationExplaination.vue?vue&type=style&index=1&id=45b0d268&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b0d268",
  null
  
)

export default component.exports